import React from "react";
import "./BooksPage.css";

const books = [
  {
    title: "Bhagavad Gita As It Is",
    image: "/assets/books/gita.jpg",
    description: "Srila Prabhupada’s commentary on the timeless scripture.",
    link: "/books/gita"
  },
  {
    title: "Bhagavad Gita As It Is",
    image: "/assets/books/gita.jpg",
    description: "Srila Prabhupada’s commentary on the timeless scripture.",
    link: "/books/gita"
  },
  {
    title: "Bhagavad Gita As It Is",
    image: "/assets/books/gita.jpg",
    description: "Srila Prabhupada’s commentary on the timeless scripture.",
    link: "/books/gita"
  },
  {
    title: "Bhagavad Gita As It Is",
    image: "/assets/books/gita.jpg",
    description: "Srila Prabhupada’s commentary on the timeless scripture.",
    link: "/books/gita"
  },
  {
    title: "Srimad Bhagavatam",
    image: "/assets/books/bhagavatam.jpg",
    description: "The ripened fruit of Vedic knowledge.",
    link: "/books/bhagavatam"
  },
  {
    title: "Chaitanya Charitamrita",
    image: "/assets/books/chaitanya.jpg",
    description: "The life and teachings of Lord Chaitanya.",
    link: "/books/chaitanya"
  }
];

function BooksPage() {
  return (
    <div className="books-page">
      <h1>Our Books Collection</h1>
      <p>Explore spiritual wisdom through these publications.</p>
      <div className="books-grid">
        {books.map((book, index) => (
          <div key={index} className="book-card">
            <img src={book.image} alt={book.title} />
            <h3>{book.title}</h3>
            <p>{book.description}</p>
            <a href={book.link} className="book-btn">Read More</a>
          </div>
        ))}
      </div>
    </div>
  );
}

export default BooksPage;
